import axios from 'axios';
import { tokenConfig } from './authActions';
import {
  REFERRAL_LOADING,
  REFERRAL_ACTIVE_LOADED,
  REFERRAL_STATS_LOADED,
  REFERRAL_ERROR
} from './types';

// Get active referral code
export const getActiveReferral = () => (dispatch, getState) => {
  dispatch({ type: REFERRAL_LOADING });
  axios
    .get('/api/referrals/active', tokenConfig(getState))
    .then(res => {
      dispatch({ type: REFERRAL_ACTIVE_LOADED, payload: res.data });
    })
    .catch(() => {
      dispatch({ type: REFERRAL_ERROR });
    });
};

// Copy referral code — marks as shared (same code, reusable)
export const copyReferral = () => (dispatch, getState) => {
  return axios
    .post('/api/referrals/copy', {}, tokenConfig(getState))
    .then(res => {
      dispatch({ type: REFERRAL_ACTIVE_LOADED, payload: res.data });
      return res.data;
    })
    .catch(() => {
      dispatch({ type: REFERRAL_ERROR });
    });
};

// Get referral stats
export const getReferralStats = () => (dispatch, getState) => {
  axios
    .get('/api/referrals/stats', tokenConfig(getState))
    .then(res => {
      dispatch({ type: REFERRAL_STATS_LOADED, payload: res.data });
    })
    .catch(() => {
      dispatch({ type: REFERRAL_ERROR });
    });
};
